export default "__VITE_ASSET__BIAfyysV__"